"use client";
import { getBounds } from "@repo/map-helpers";
import { PathResponse } from "@repo/shared-types";
import { useRef } from "react";
import MapGL, { Layer, MapRef, NavigationControl, Source } from "react-map-gl";

import {
  BIKING_LINE_PAINT_FALLBACK,
  BIKING_LOOP_LINE_PAINT_FALLBACK,
  LINE_LAYOUT,
  MAP_CENTER,
  MAP_STYLE,
  WALKING_LINE_PAINT_FALLBACK,
  WALKING_LOOP_LINE_PAINT_FALLBACK,
  ZOOM_ANIMATION_OPTIONS,
} from "./consts";

const lines = {
  biking: BIKING_LINE_PAINT_FALLBACK,
  hiking: WALKING_LINE_PAINT_FALLBACK,
};

const loop_lines = {
  biking: BIKING_LOOP_LINE_PAINT_FALLBACK,
  hiking: WALKING_LOOP_LINE_PAINT_FALLBACK,
};

export function SmallMap({ path }: { path: PathResponse }) {
  const mapRef = useRef<MapRef>(null);
  return (
    <MapGL
      mapboxAccessToken={
        process.env.NEXT_PUBLIC_MAXBOX_TOKEN ||
        "pk.eyJ1IjoiLWthdHJpbmU4NiIsImEiOiJjbHhuM2o2Z3QwZW9tMnJzZXdyZ3d6bjVkIn0.myE9RFFZikeU-1cB0Hb69w"
      }
      initialViewState={{ ...MAP_CENTER }}
      mapStyle={MAP_STYLE}
      style={{
        height: "400px",
        width: "100%",
      }}
      ref={mapRef}
      scrollZoom={false}
      styleDiffing={true}
      onLoad={() => {
        const { minLat, minLng, maxLat, maxLng } = getBounds([path]);
        mapRef.current?.fitBounds(
          [
            [minLng, minLat],
            [maxLng, maxLat],
          ],
          ZOOM_ANIMATION_OPTIONS
        );
      }}
    >
      <NavigationControl showCompass={false} />
      <Source
        type="geojson"
        id={`sourceLineLayer_${path.id}`}
        key={path.id}
        data={path.geoJson}
      >
        <Layer
          id={path.id}
          type="line"
          layout={LINE_LAYOUT}
          paint={
            (path?.pathId?.length ?? 0) > 8
              ? loop_lines[path.type]
              : lines[path.type]
          }
        />
      </Source>
    </MapGL>
  );
}
